import { useCallback, useEffect, useState } from 'react'
import orderBy from 'lodash/orderBy'
import { Sale } from '../../models/sale'
import { WEB_REGISTER } from '../web-register.constant'
import {
  useRegisterManager,
  useRetailerSettingsManager,
  useSaleSyncManager,
  useUserManager,
} from '../../ng-compat/hooks'
import { useAppSelector } from '../../state/hooks'
import { selectActiveOutletId } from '../../state/slices/posState/posStateSlice'

export const useErroredSales = () => {
  const [erroredSales, setErroredSales] = useState<Sale[]>([])
  const [erroredSalesFileUrl, setErroredSalesFileUrl] = useState<string>('')
  const [outletTimeZone, setOutletTimeZone] = useState<string>('')
  const saleSyncManager = useSaleSyncManager()
  const retailerSettingsManager = useRetailerSettingsManager()
  const userManager = useUserManager()
  const registerManager = useRegisterManager()
  const outletId = useAppSelector(selectActiveOutletId)

  const generateFile = useCallback(() => {
    const retailerSettings = retailerSettingsManager.get()
    const registerData = {
      clientName: WEB_REGISTER.APPLICATION_NAME,
      clientVersion: WEB_REGISTER.CLIENT_VERSION,
      domainPrefix: retailerSettings.domain_prefix,
      retailerId: retailerSettings.id,
      userId: userManager.getLoggedInUser().id,
    }
    saleSyncManager
      .generateErroredSalesFile(registerData)
      .then(url => setErroredSalesFileUrl(url))
  }, [retailerSettingsManager, userManager, saleSyncManager])

  useEffect(() => {
    const fetchSales = async () => {
      const sales = await saleSyncManager.getErroredSales()
      setErroredSales(orderBy(sales, ['saleDate'], ['desc']))
    }
    fetchSales()
    saleSyncManager.on('saleSyncRetryComplete', fetchSales)
    return () => {
      saleSyncManager.off('saleSyncRetryComplete', fetchSales)
      saleSyncManager.clearErroredSalesFile()
    }
  }, [saleSyncManager])

  useEffect(() => {
    generateFile()
  }, [generateFile])

  useEffect(() => {
    if (outletId) {
      registerManager.getOutletById(outletId).then(outlet => {
        if (outlet) {
          setOutletTimeZone(outlet.time_zone)
        }
      })
    }
  }, [registerManager, outletId])

  return {
    erroredSales,
    erroredSalesFileUrl,
    outletTimeZone,
  }
}
